import { rei } from "@/services/api"

class ProfissoesService {
  static searchProfissaoByName (descricao) {
    // TODO: depois irá vir da constant ocupacao e sairá do service
    // TODO: identificar o motivo do v-select em profissocesCBO disparar erro quando puxamos da constante
    return rei.get(`repositorio/ocupacao?descricao=${descricao}`).then(res => res.data)
  }
}

export default ProfissoesService
